import { ENUM_STATUS_WINDOW } from "../../store/chatSlice";
import { useAppSelector } from "../../store/index.ts";

export default function useStreamStatus() {
  const status = useAppSelector((state) => state.chat.statusWindow);

  const isStream = status === ENUM_STATUS_WINDOW.stream;
  const isLoading = status === ENUM_STATUS_WINDOW.loading;
  const isOffline = status === ENUM_STATUS_WINDOW.offline;

  return { isStream, isLoading, isOffline, status };
}
